﻿import { SecurityRow } from "@/ServerTypes/Data/SecurityRow";
import { Decorators } from "@serenity-is/corelib";
import { FormatServiceLookupPickerBase, FormatServiceLookupEditorOptions } from "@/Data/List/FormatServiceLookupEditor";
import { SecurityPickerDialog } from "./SecurityPickerDialog";
import { SecurityService } from "@/ServerTypes/Data/SecurityService";

export interface SecurityPickerOptions extends FormatServiceLookupEditorOptions {
    filterField?: string;
    filterValue?: string;
    multiple?: boolean;
    resultFormat?: string;
    selectionFormat?: string;
    textFormat?: string;
}

@Decorators.registerEditor("Matrix.Data.SecurityPicker")
export class SecurityPicker extends FormatServiceLookupPickerBase<SecurityPickerOptions, SecurityRow>  {

    constructor(hidden: JQuery, options: SecurityPickerOptions) {
        if (!options.idField?.length)
            options.idField = SecurityRow.idProperty;
        if (!options.textField?.length)
            options.textField = SecurityRow.nameProperty;
        if (!options.resultFormat?.length)
            options.service = SecurityService.baseUrl + "/List";

        super(hidden, options);
    }

    handleEditClick() {
        var dlg = new SecurityPickerDialog();
        dlg.criteria = this.getFilterCriteria();
        dlg.allowClear = true;
        dlg.value = this.values;
        dlg.dialogOpen();
        dlg.onSuccess = sel => {
            this.values = dlg.value;
            return true;
        }
    }

    protected displayName() {
        return "securities";
    }

    protected getLookupKey() {
        return SecurityRow.lookupKey;
    }
}
